module.exports = {
      id: "politics-usage",
      viewBox: "0 0 93.75 88.955",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#politics",
      toString: function () {
        return this.url;
      }
    }